<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  @if (!props.multiple) {
    <cap-dropdown
      [formControl]="formControl"
      [label]="props.label"
      [placeholder]="props.placeholder || ' '"
      [options]="props.options$.asObservable() | async"
      [optionLabel]="props.label_key"
      [optionValue]="props.value_key"
      [hidden]="props.is_hidden"
      [disabled]="props.is_disabled"
      [appendTo]="'body'"
      [sortAlphabetically]="false"
      [withImages]="!!props.image_key">
      <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
    </cap-dropdown>
  }

  @if (props.multiple && (props.options$ | async); as options) {
    <cap-multi-select
      [formControl]="formControl"
      [label]="props.label"
      [defaultLabel]="props.placeholder || ''"
      [options]="options"
      [optionLabel]="props.label_key"
      [optionValue]="props.value_key"
      [hidden]="props.is_hidden"
      [readonly]="props.readonly || props.is_disabled"
      [appendTo]="'body'">
    </cap-multi-select>
  }
</div>
